import { useState } from "react";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import FilledButton from "@/components/common/filled-button";
import { getActiveLoggingService } from "@/services/logger/logging-service";

type Props = {
  urls: string[];
};

const StemDownloadZipButton = ({ urls }: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const fetchFile = async (
    url: string,
  ): Promise<{ name: string; data: Blob }> => {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch ${url}`);
    }
    const contentDisposition = response.headers.get("content-disposition");
    const fileName = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/['"]/g, "") || "file"
      : url.split("/").pop() || "file";
    const blob = await response.blob();
    return { name: fileName, data: blob };
  };

  const handleDownloadZip = async () => {
    setIsLoading(true);
    const zip = new JSZip();

    const urlList = urls.map((url) => url.trim()).filter((url) => url);
    if (urlList.length === 0) {
      setIsLoading(false);
      return;
    }

    try {
      for (const url of urlList) {
        try {
          const { name, data } = await fetchFile(url);
          zip.file(name, data);
        } catch (error) {
          getActiveLoggingService().logError(error as Error);
        }
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, "stem-split-files.zip");
    } catch (error) {
      getActiveLoggingService().logError(error as Error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <FilledButton
        text={isLoading ? "Downloading..." : "Download .ZIP"}
        onClick={handleDownloadZip}
        disabled={isLoading}
        backgroundColor={"#FF5722"}
        color={"#141414"}
        padding={"12px 12px"}
        textTransform={"uppercase"}
      />
    </div>
  );
};

export default StemDownloadZipButton;
